import { render, staticRenderFns } from "./deliverySettings.vue?vue&type=template&id=2bc2ee2b"
import script from "./deliverySettings.vue?vue&type=script&lang=js"
export * from "./deliverySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc2ee2b')) {
      api.createRecord('2bc2ee2b', component.options)
    } else {
      api.reload('2bc2ee2b', component.options)
    }
    module.hot.accept("./deliverySettings.vue?vue&type=template&id=2bc2ee2b", function () {
      api.rerender('2bc2ee2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Marketplace/deliverySettings.vue"
export default component.exports